import { createContext } from 'utils/react-helpers';
const [BlacklistProvider, useBlacklist] = createContext({
  name: 'BlacklistContext',
});

export { BlacklistProvider, useBlacklist };
